<template>
  <div class="aside_1">
    <div class="baseSetting">
      <h4>基本设置</h4>
      <div class="baseInfo">
        <div class="baseInfo_top">
          <div class="userIcon">
            <img :src="avatar" style="width: 70px; height: 70px; border-radius: 50%" />
          </div>
          <div class="userDes">
            <p>
              昵称：
              <label v-show="!editingNickname">{{ nickname || '（未设置）' }}</label>
              <img v-show="!editingNickname" src="/img/nickRename.png" alt="" style="margin-left: 10px; cursor: pointer" @click="editingNickname = true" />
              <input v-show="editingNickname" v-model="userObj.name" type="text" maxlength="50" class="nicknameStyle" />
              <span v-show="editingNickname" @click="saveNickname">保存</span>
            </p>
          </div>
        </div>
        <form id="upload" enctype="multipart/form-data" method="post">
          <el-upload
            class="upload-demo"
            action="/realNet/customer/updateCustomerAvatar"
            name="avatar"
            :headers="headers"
            :on-success="handleSucc"
            :show-file-list="false"
            list-type="picture"
          >
            <el-button size="small" type="primary">更改头像</el-button>
          </el-upload>
        </form>
      </div>
    </div>

    <div class="securitySetting">
      <h4>安全设置</h4>
      <div class="securityWrap">
        <div class="securityItem">
          <div class="securityItemImg">
            <img src="/img/mine_phone.png" alt="" />
          </div>
          <div class="securityItem_right">
            <p style="display: flex; justify-content: space-between">
              <span class="normalSty">{{ phoneNum ? '手机已验证' : '手机未绑定' }}</span>
              <span class="activeSty" style="cursor: pointer" @click="phoneNum ? changePhoneFn() : bindPhoneFn()">{{ phoneNum ? '修改' : '绑定' }}手机号</span>
            </p>
            <p class="pSty">
              <span v-if="phoneNum" style="font-size: 18px; color: #000; font-weight: bold">{{ phoneNum }}</span>
              <span v-else><i style="color: #CADCDC; font-size: 16px">暂无绑定手机号</i></span>
            </p>
          </div>
        </div>
        <div class="securityItem">
          <div class="securityItemImg">
            <img src="/img/mine_email.png" alt="" />
          </div>
          <div class="securityItem_right">
            <p style="display: flex; justify-content: space-between">
              <span class="normalSty">{{ email ? '邮箱已绑定' : '邮箱未绑定' }}</span>
              <span class="activeSty" style="cursor: pointer" @click="email ? changeEmailFn() : bindEmailFn()">{{ email ? '修改' : '绑定' }}邮箱</span>
            </p>
            <p>
              <span v-if="email" style="font-size: 18px; color: #000; font-weight: bold">{{ email }}</span>
              <span v-else><i style="color: #CADCDC; font-size: 16px">暂无邮箱信息</i></span>
            </p>
          </div>
        </div>
        <div class="securityItem">
          <div class="securityItemImg">
            <img src="/img/mine_pwd.png" alt="" />
          </div>
          <div class="securityItem_right">
            <p>
              <span class="activeSty" style="margin-right: 35px; cursor: pointer" @click="changePwdFn">修改密码</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="DIY">
      <h4>个性设置</h4>
      <div class="DIYWrap">
        <div class="diyItem" v-for="(item, index) in ctxMap" :key="item.ref">
          <div class="diyItem_left">
            {{ item.label }}：
            <el-select v-if="item.options" v-show="item.editing" v-model="userObj[item.ref]" size="mini" style="width: 200px">
              <el-option v-for="opt in item.options" :key="opt" :label="opt" :value="opt" />
            </el-select>
            <el-date-picker v-else-if="item.ref === 'birthday'" v-show="item.editing" v-model="userObj[item.ref]" type="date" size="mini" value-format="yyyy-MM-dd" style="width: 200px" />
            <input v-else v-show="item.editing" v-model="userObj[item.ref]" type="text" />
            <label v-show="!item.editing">{{ userObj[item.ref] || '（未设置）' }}</label>
          </div>
          <span @click="toggleEdit(index)">{{ item.editing ? '保存' : '修改' }}</span>
        </div>
      </div>
    </div>

    <div class="toast" v-if="showPhoneDialog">
      <el-dialog :visible.sync="showPhoneDialog" :modal-append-to-body="false">
        <div slot="title" class="jumFpeedback_head">
          <img src="/img/logo.e85e07f3.png" alt="" />
          <b></b>
          <span>更改手机号</span>
        </div>
        <div style="width: 70%; margin: 0 auto; padding-top: 30px">
          <el-steps :active="phoneStep" finish-status="success">
            <el-step title="验证"></el-step>
            <el-step title="修改"></el-step>
          </el-steps>
        </div>
        <div class="jumpFeedback_body" v-if="phoneStep === 1">
          <div class="user">
            <input type="text" v-model="phoneForm.phone" placeholder="在此输入原手机号" />
          </div>
          <div class="code">
            <el-input v-model="phoneForm.code" placeholder="请输入验证码" />
            <el-button type="primary" @click="sendPhoneCode">{{ phoneCodeBtn }}</el-button>
          </div>
          <div class="tip"><p>若无法收到短信验证码，请您与我们的客服联系</p></div>
          <div class="loginBtn active" @click="phoneNextStep"><span>下一步</span></div>
        </div>
        <div class="jumpFeedback_body" v-else>
          <div class="user">
            <input type="text" v-model="phoneForm.newPhone" placeholder="在此输入新手机号" />
          </div>
          <div class="code">
            <el-input v-model="phoneForm.newCode" placeholder="请输入验证码" />
            <el-button type="primary" @click="sendNewPhoneCode">{{ phoneCodeBtn }}</el-button>
          </div>
          <div class="tip"><p>若无法收到短信验证码，请您与我们的客服联系</p></div>
          <div class="loginBtn active" @click="phoneEditSure"><span>保存</span></div>
        </div>
      </el-dialog>
    </div>

    <div class="toast" v-if="showEmailDialog">
      <el-dialog :visible.sync="showEmailDialog" :modal-append-to-body="false">
        <div slot="title" class="jumFpeedback_head">
          <img src="/img/logo.e85e07f3.png" alt="" />
          <b></b>
          <span>{{ email ? '更改邮箱' : '绑定邮箱' }}</span>
        </div>
        <div style="width: 70%; margin: 0 auto; padding-top: 30px" v-if="email">
          <el-steps :active="emailStep" finish-status="success">
            <el-step title="验证"></el-step>
            <el-step title="修改"></el-step>
          </el-steps>
        </div>
        <div class="jumpFeedback_body" v-if="!email || emailStep === 1">
          <div class="user">
            <input type="text" v-model="emailForm.email" :placeholder="email ? '在此输入原邮箱' : '在此输入邮箱'" />
          </div>
          <div class="code">
            <el-input v-model="emailForm.code" placeholder="请输入验证码" />
            <el-button type="primary" @click="sendEmailCode">{{ emailCodeBtn }}</el-button>
          </div>
          <div class="tip"><p>若无法收到验证码，请您与我们的客服联系</p></div>
          <div class="loginBtn active" @click="emailNextStep"><span>{{ email ? '下一步' : '保存' }}</span></div>
        </div>
        <div class="jumpFeedback_body" v-else>
          <div class="user">
            <input type="text" v-model="emailForm.newEmail" placeholder="在此输入新邮箱" />
          </div>
          <div class="code">
            <el-input v-model="emailForm.newCode" placeholder="请输入验证码" />
            <el-button type="primary" @click="sendNewEmailCode">{{ emailCodeBtn }}</el-button>
          </div>
          <div class="tip"><p>若无法收到验证码，请您与我们的客服联系</p></div>
          <div class="loginBtn active" @click="emailEditSure"><span>保存</span></div>
        </div>
      </el-dialog>
    </div>

    <div class="toast" v-if="showPwdDialog">
      <el-dialog :visible.sync="showPwdDialog" :modal-append-to-body="false">
        <div slot="title" class="jumFpeedback_head">
          <img src="/img/logo.e85e07f3.png" alt="" />
          <b></b>
          <span>修改密码</span>
        </div>
        <div class="jumpFeedback_body">
          <div class="user">
            <input type="password" v-model="pwdForm.oldPwd" placeholder="在此输入原密码" />
          </div>
          <div class="user">
            <input type="password" v-model="pwdForm.newPwd" placeholder="在此输入新密码" />
          </div>
          <div class="user">
            <input type="password" v-model="pwdForm.confirmPwd" placeholder="再次输入新密码" />
          </div>
          <div class="loginBtn active" @click="updatePassword"><span>保存</span></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getToken, setUser } from '@/utils/auth'

export default {
  name: 'PersonalSettings',
  props: { userInfo: Object },
  data() {
    return {
      editingNickname: false,
      nickname: '',
      avatar: '/img/newPages/touxiang.png',
      phoneNum: '',
      email: '',
      userObj: { name: '', gender: '', birthday: '', region: '' },
      ctxMap: [
        { label: '性别', ref: 'gender', editing: false, options: ['男', '女', '保密'] },
        { label: '生日', ref: 'birthday', editing: false },
        { label: '地区', ref: 'region', editing: false }
      ],
      headers: { token: getToken() },
      showPhoneDialog: false,
      showEmailDialog: false,
      showPwdDialog: false,
      phoneStep: 1,
      emailStep: 1,
      phoneForm: { phone: '', code: '', newPhone: '', newCode: '' },
      emailForm: { email: '', code: '', newEmail: '', newCode: '' },
      pwdForm: { oldPwd: '', newPwd: '', confirmPwd: '' },
      phoneTimer: null,
      emailTimer: null,
      phoneTime: 59,
      emailTime: 59,
      phoneIsClick: false,
      emailIsClick: false
    }
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val) {
          this.nickname = val.name || ''
          this.avatar = val.avatar || '/img/newPages/touxiang.png'
          this.phoneNum = val.phone || val.phoneNum || ''
          this.email = val.email || ''
          this.userObj.name = val.name || ''
          this.userObj.gender = val.gender || ''
          this.userObj.birthday = val.birthday || ''
          this.userObj.region = val.region || ''
        }
      },
      immediate: true
    }
  },
  computed: {
    phoneCodeBtn() {
      return this.phoneIsClick ? `重新发送${this.phoneTime}s` : '获取验证码'
    },
    emailCodeBtn() {
      return this.emailIsClick ? `重新发送${this.emailTime}s` : '获取验证码'
    }
  },
  methods: {
    handleSucc(res) {
      if (res.code === 200) {
        this.$message({ message: '头像更新成功', type: 'success' })
        this.$emit('refresh')
      }
    },
    saveNickname() {
      this.editingNickname = false
      this.$axios({
        url: '/realNet/customer/updateCustomer',
        method: 'post',
        data: { name: this.userObj.name },
        headers: { token: getToken() }
      }).then(res => {
        if (res.data.code === 200) {
          this.nickname = this.userObj.name
          this.$message({ message: '昵称修改成功', type: 'success' })
          this.syncUser({ name: this.userObj.name })
        }
      })
    },
    toggleEdit(index) {
      const item = this.ctxMap[index]
      if (item.editing) {
        item.editing = false
        this.$axios({
          url: '/realNet/customer/updateCustomer',
          method: 'post',
          data: { [item.ref]: this.userObj[item.ref] },
          headers: { token: getToken() }
        }).then(res => {
          if (res.data.code === 200) {
            this.$message({ message: '修改成功', type: 'success' })
          }
        })
      } else {
        item.editing = true
      }
      this.ctxMap = [...this.ctxMap]
    },
    changePhoneFn() { this.phoneStep = 1; this.showPhoneDialog = true },
    bindPhoneFn() { this.phoneStep = 1; this.showPhoneDialog = true },
    changeEmailFn() { this.emailStep = 1; this.showEmailDialog = true },
    bindEmailFn() { this.emailStep = 1; this.showEmailDialog = true },
    changePwdFn() { this.showPwdDialog = true },
    startTimer(type) {
      if (type === 'phone') {
        this.phoneIsClick = true
        this.phoneTime = 59
        this.phoneTimer = setInterval(() => {
          this.phoneTime--
          if (this.phoneTime === 0) { clearInterval(this.phoneTimer); this.phoneTime = 59; this.phoneIsClick = false }
        }, 1000)
      } else {
        this.emailIsClick = true
        this.emailTime = 59
        this.emailTimer = setInterval(() => {
          this.emailTime--
          if (this.emailTime === 0) { clearInterval(this.emailTimer); this.emailTime = 59; this.emailIsClick = false }
        }, 1000)
      }
    },
    sendPhoneCode() {
      if (this.phoneIsClick) return
      if (!this.phoneForm.phone) { this.$message({ message: '请先输入手机号', type: 'warning' }); return }
      this.$axios({ method: 'post', url: '/realNet/customer/sendSms', data: { phoneNumOrEmail: this.phoneForm.phone }, headers: { token: getToken() } })
      this.startTimer('phone')
    },
    sendNewPhoneCode() {
      if (this.phoneIsClick) return
      if (!this.phoneForm.newPhone) { this.$message({ message: '请先输入新手机号', type: 'warning' }); return }
      this.$axios({ method: 'post', url: '/realNet/customer/sendSms', data: { phoneNumOrEmail: this.phoneForm.newPhone }, headers: { token: getToken() } })
      this.startTimer('phone')
    },
    sendEmailCode() {
      if (this.emailIsClick) return
      if (!this.emailForm.email) { this.$message({ message: '请先输入邮箱', type: 'warning' }); return }
      this.$axios({ method: 'post', url: '/realNet/customer/sendSms', data: { phoneNumOrEmail: this.emailForm.email }, headers: { token: getToken() } })
      this.startTimer('email')
    },
    sendNewEmailCode() {
      if (this.emailIsClick) return
      if (!this.emailForm.newEmail) { this.$message({ message: '请先输入新邮箱', type: 'warning' }); return }
      this.$axios({ method: 'post', url: '/realNet/customer/sendSms', data: { phoneNumOrEmail: this.emailForm.newEmail }, headers: { token: getToken() } })
      this.startTimer('email')
    },
    phoneNextStep() {
      if (!this.phoneForm.phone || !this.phoneForm.code) {
        this.$message({ message: '请输入手机号和验证码', type: 'warning' }); return
      }
      this.$axios({
        method: 'put',
        url: '/realNet/customer/updatePhoneNum',
        headers: { token: getToken() },
        data: { phoneNumOrEmail: this.phoneForm.phone, firstCode: this.phoneForm.code, step: 0 }
      }).then(res => {
        if (res.data.code === 200) {
          this.$message({ message: '验证通过', type: 'success' })
          this.phoneStep = 2
          this.phoneIsClick = false
          this.phoneTime = 59
          if (this.phoneTimer) clearInterval(this.phoneTimer)
        } else {
          this.$message({ message: res.data.message, type: 'warning' })
        }
      })
    },
    phoneEditSure() {
      if (!this.phoneForm.newPhone || !this.phoneForm.newCode) {
        this.$message({ message: '请输入新手机号和验证码', type: 'warning' }); return
      }
      this.$axios({
        method: 'put',
        url: '/realNet/customer/updatePhoneNum',
        headers: { token: getToken() },
        data: { phoneNumOrEmail: this.phoneForm.newPhone, firstCode: this.phoneForm.newCode, step: 1 }
      }).then(res => {
        if (res.data.code === 200) {
          this.$message({ message: '手机号修改成功', type: 'success' })
          this.showPhoneDialog = false
          this.$emit('refresh')
        } else {
          this.$message({ message: res.data.message, type: 'warning' })
        }
      })
    },
    emailNextStep() {
      if (!this.emailForm.email || !this.emailForm.code) {
        this.$message({ message: '请输入邮箱和验证码', type: 'warning' }); return
      }
      if (!this.email) {
        this.$axios({
          method: 'post',
          url: '/realNet/customer/bindingEmail',
          headers: { token: getToken() },
          data: { phoneNumOrEmail: this.emailForm.email, code: this.emailForm.code }
        }).then(res => {
          if (res.data.code === 200) {
            this.$message({ message: '邮箱绑定成功', type: 'success' })
            this.showEmailDialog = false
            this.$emit('refresh')
          } else {
            this.$message({ message: res.data.message, type: 'warning' })
          }
        })
        return
      }
      this.$axios({
        method: 'put',
        url: '/realNet/customer/updateEmail',
        headers: { token: getToken() },
        data: { phoneNumOrEmail: this.emailForm.email, firstCode: this.emailForm.code, step: 0 }
      }).then(res => {
        if (res.data.code === 200) {
          this.$message({ message: '验证通过', type: 'success' })
          this.emailStep = 2
          this.emailIsClick = false
          this.emailTime = 59
          if (this.emailTimer) clearInterval(this.emailTimer)
        } else {
          this.$message({ message: res.data.message, type: 'warning' })
        }
      })
    },
    emailEditSure() {
      if (!this.emailForm.newEmail || !this.emailForm.newCode) {
        this.$message({ message: '请输入新邮箱和验证码', type: 'warning' }); return
      }
      this.$axios({
        method: 'put',
        url: '/realNet/customer/updateEmail',
        headers: { token: getToken() },
        data: { phoneNumOrEmail: this.emailForm.newEmail, firstCode: this.emailForm.newCode, step: 1 }
      }).then(res => {
        if (res.data.code === 200) {
          this.$message({ message: '邮箱修改成功', type: 'success' })
          this.showEmailDialog = false
          this.$emit('refresh')
        } else {
          this.$message({ message: res.data.message, type: 'warning' })
        }
      })
    },
    updatePassword() {
      if (this.pwdForm.newPwd !== this.pwdForm.confirmPwd) {
        this.$message({ message: '两次密码不一致', type: 'warning' })
        return
      }
      this.$axios({
        url: '/realNet/customer/updatePassword',
        method: 'post',
        data: { oldPassword: this.pwdForm.oldPwd, newPassword: this.pwdForm.newPwd },
        headers: { token: getToken() }
      }).then(res => {
        if (res.data.code === 200) {
          this.$message({ message: '密码修改成功', type: 'success' })
          this.showPwdDialog = false
        } else {
          this.$message({ message: res.data.message, type: 'error' })
        }
      })
    },
    syncUser(updates) {
      const user = { ...this.userInfo, ...updates }
      setUser(JSON.stringify(user))
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
.aside_1 {
  width: 930px;
}

.baseSetting {
  margin-bottom: 35px;

  h4 {
    font-size: 14px;
    margin-bottom: 15px;
  }

  .baseInfo {
    width: 100%;
    height: 140px;
    padding: 16px;
    border: 1px solid #eaeced;
    background-color: #f9f9f9;
    box-sizing: border-box;

    .baseInfo_top {
      width: 100%;
      height: 75px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;

      .userIcon {
        width: 70px;
        height: 70px;
        margin-right: 30px;
        background-color: #d2e0e2;
        border-radius: 50%;
        overflow: hidden;
      }

      .userDes {
        width: 50%;
        height: 70px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 14px;

        p .nicknameStyle {
          width: 200px;
          display: inline-block;
          border: 1px solid #3bc0d0;
          font-size: 14px;
          background-color: transparent;
        }

        p span {
          color: #3bc0d0;
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }

    .spanSty {
      width: 70px;
      height: 28px;
      border: 1px solid #3bc0d0;
      color: #3bc0d0;
      font-size: 13px;
      border-radius: 14px;
      display: inline-block;
      line-height: 28px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.securitySetting {
  margin-bottom: 40px;

  h4 {
    font-size: 14px;
  }

  .securityWrap {
    width: 100%;
    height: 85px;
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .securityItem {
      width: 300px;
      height: 85px;
      display: flex;
      align-items: center;
      border: 1px solid #3bc0d0;
      background-color: #f9fbfb;

      .securityItemImg {
        width: 42px;
        height: 100%;
        margin: 0 10px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 32px;
          height: auto;
        }
      }

      .securityItem_right {
        width: 220px;
        height: 100%;
        padding: 15px 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .normalSty {
          font-size: 14px;
          color: #000;
        }

        .activeSty {
          font-size: 14px;
          color: #2cb5c5;
        }

        .pSty {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}

.DIY {
  h4 {
    font-size: 14px;
  }

  .DIYWrap {
    width: 926px;
    padding: 20px;
    border: 1px solid #eaeced;
    margin-top: 15px;
    box-sizing: border-box;

    .diyItem {
      width: 100%;
      height: 40px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > span {
        color: #2cb5c5;
        cursor: pointer;
      }

      .diyItem_left {
        input {
          width: 200px;
          height: 25px;
          border: 1px solid #3bc0d0;
          line-height: 25px;
          font-size: 14px;
          color: #888;
          background-color: transparent;
        }
      }
    }
  }
}

.toast {
  ::v-deep .el-dialog {
    width: 480px;
    border-radius: 8px;
  }

  ::v-deep .el-dialog__header {
    width: 100%;
    box-sizing: border-box;
  }

  ::v-deep .el-dialog__body,
  ::v-deep .el-dialog__footer {
    padding: 0;
  }

  .jumFpeedback_head {
    display: flex;
    align-items: center;

    img { margin-top: 0; }

    b {
      width: 4px;
      height: 4px;
      margin: 0 10px;
      background-color: #3bc0d0;
      border-radius: 50%;
      display: inline-block;
    }

    span {
      font-size: 18px;
      color: #3bc0d0;
    }
  }

  .jumpFeedback_body {
    width: 100%;
    padding: 40px 61px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;

    .user {
      width: 100%;
      height: 55px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e1e9eb;
      display: flex;
      align-items: center;

      input {
        width: 90%;
        height: 30px;
        border: none;
        outline: none;
        font-size: 16px;

        &::placeholder { color: #ccc; }
      }
    }

    .code {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      ::v-deep .el-input {
        width: 60%;
      }
    }

    .tip {
      width: 100%;
      margin-top: 15px;

      p {
        font-size: 12px;
        color: #999;
      }
    }

    .loginBtn {
      width: 360px;
      height: 50px;
      margin-top: 20px;
      background-color: #dde1e2;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 18px;
        color: #fff;
        letter-spacing: 1px;
      }

      &.active {
        background-color: #3bc0d0;
      }
    }
  }
}
</style>
